import { render, staticRenderFns } from "./AddCommunication.vue?vue&type=template&id=44fdb20e&scoped=true"
import script from "./AddCommunication.vue?vue&type=script&lang=ts"
export * from "./AddCommunication.vue?vue&type=script&lang=ts"
import style0 from "./AddCommunication.vue?vue&type=style&index=0&id=44fdb20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fdb20e",
  null
  
)

export default component.exports